template = require('./meter.html.slim')

angular.module('wbComponents').directive 'meter', ->
  replace: true
  restrict: "E"
  scope: true

  templateUrl: template

  link: ($scope, $el, $attrs) ->
    $scope.style = { width: '0%'; }
    getWidth = ->
      value = Number($attrs.value) or 0
      min = Number($attrs.min) or 0
      max = Number($attrs.max) or 0
      width = if value <= min
      else if max and value >= max
        100
      else
        (value - min) * 100 / (max - min)
      $scope.style.width = "#{width}%"
    $attrs.$observe('value', getWidth)
    $attrs.$observe('min', getWidth)
    $attrs.$observe('max', getWidth)
